module.exports = __webpack_public_path__ + "static/img/button-right-icon.7d994e42.svg";